import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="form-optimization"
export default class extends Controller {
  static targets = ["password"];

  connect() {
    console.log("connected to form-optimization controller");
  }

  omitEmptyPassword() {
    const field = this.hasPasswordTarget ? this.passwordTarget : null;
    console.log(field.value);
    if (field && !field.value) field.disabled = true;
  }
}
